import styled from 'styled-components';

const GridContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  pointer-events: none;
  z-index: 99;
`;

const GridSVG = styled.svg`
  width: 100%;
  height: 100%;
`;

const CornerGrid = () => {
  const gridSize = 60;
  const width = 2000; // Large enough to cover screen
  const height = 1200; // Large enough to cover screen
  
  return (
    <GridContainer>
      <GridSVG>
        <defs>
          <mask id="cornerMask">
            <rect width="100%" height="100%" fill="black" />
            
            <radialGradient id="fadeLeft" cx="0" cy="0" r="0.6">
              <stop offset="0%" stopColor="white" />
              <stop offset="100%" stopColor="black" />
            </radialGradient>
            <radialGradient id="fadeRight" cx="100%" cy="0" r="0.4">
              <stop offset="0%" stopColor="white" />
              <stop offset="100%" stopColor="black" />
            </radialGradient>
            <rect width="50%" height="100%" fill="url(#fadeLeft)" />
            <rect x="50%" width="50%" height="100%" fill="url(#fadeRight)" />
          </mask>
        </defs>
        
        <g mask="url(#cornerMask)" strokeWidth="1" stroke="rgba(255,255,255,0.2)" strokeDasharray="5,5">
          {/* Vertical lines */}
          {Array.from({ length: Math.ceil(width/gridSize) }, (_, i) => (
            <line 
              key={`v${i}`}
              x1={i * gridSize}
              y1="0"
              x2={i * gridSize}
              y2={height}
            />
          ))}
          
          {/* Horizontal lines */}
          {Array.from({ length: Math.ceil(height/gridSize) }, (_, i) => (
            <line
              key={`h${i}`}
              x1="0"
              y1={i * gridSize}
              x2={width}
              y2={i * gridSize}
            />
          ))}
        </g>
      </GridSVG>
    </GridContainer>
  );
};

export default CornerGrid;